<template>
  <div class="advert-top" v-if="message">
    <!--		<div class="ico-horn">-->
    <!--			<img src="https://t7.baidu.com/it/u=2222012502,2910942051&fm=193" alt="">-->
    <!--		</div>-->
    <!-- 滚动文字区域 -->
    <div class="marquee-wrap">
      <ul class="marquee-box" id="marquee-box">
        <li class="marquee-list" v-for="(item,i) in messageList" :id="i==1 ? 'marquee' : ''">
          <div class="operatingList" :style="{background:dynamicColor.rgba}">
            <img :src="item.avatarUrl" alt="">
            <p :style="{color:dynamicColor.rgb}">{{ item.actionName }}</p>
          </div>
        </li>

      </ul>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  props: {
    message: {
      type: Array,
      required: true
    },
    themeRGBColor: '',
    themeRGBAColor: '',
  },
  data() {
    return {
      dynamicColor: {},
      messageList: []
    };
  },
  watch: {
    themeRGBColor() {
      this.dynamicColor = {
        rgb: this.themeRGBColor,
        rgba: this.themeRGBAColor
      };
    },
    message: {
      handler(val){
        this.messageList = val;
      },
      deep: true
    }
  },
  created() {

  },
  mounted: function () {

    // 延时滚动
    setTimeout(() => {
      this.runMarquee();
    }, 1000);
    // console.log(this.message)
  },
  methods: {
    runMarquee() {
      // 获取文字 计算后宽度
      var width = document.getElementById("marquee-box").getBoundingClientRect().width,
        marquee = document.getElementById("marquee-box"),
        dou = document.body.clientWidth,
        disx = 0; // 位移距离
      // console.log(width)
      //设置位移
      setInterval(() => {
        disx--; // disx-=1; 滚动步长
        if (-disx >= width - dou + 50) {
          disx = 10; // 如果位移超过文字宽度，则回到起点  marquee-list的margin值
        }
        // marquee.style.transform = 'translateX(' + disx + 'px)'
        marquee.style.left = disx + "px";
      }, 30); //滚动速度
    }
  }
};
// JavaScript Document
// (function px2rem(doc, win) {
//     var docEl = doc.documentElement,
//         resizeEvt = "orientationchange" in window ? "orientationchange" : "resize",
//         recalc = function() {
//             var clientWidth = docEl.clientWidth;
//             if (!clientWidth) return;
//             docEl.style.fontSize = 100 * (clientWidth / 750) + "px";
//         };
//     if (!doc.addEventListener) return;
//     // 窗口大小发生变化，初始化
//     win.addEventListener(resizeEvt, recalc, false);
//     doc.addEventListener("DOMContentLoaded", recalc, false);
//     setTimeout(function() {
//         px2rem(doc, win);
//     }, 200);
// })(document, window);
</script>
<style scoped>
body,
div,
html,
img,
li,
ul {
  margin: 0;
  padding: 0;
  border: 0;
}

li {
  list-style: none;
}

.advert-top {
  position: relative;
  display: flex;
  width: 100%;
  height: 60px;
  /*background-color: #fff;*/
  /*color: #2d8cf0;*/
  font-size: 14px;
  align-items: center;
}

.ico-horn {
  display: flex;
  margin-right: 10px;
  width: 14px;
  height: 14px;
  justify-content: center;
  align-items: center;
}

.ico-horn > img {
  width: 30px;
  height: 30px;
}

/* 以下代码与滚动相关 */
.marquee-wrap {
  position: relative;
  display: flex;
  overflow: hidden;
  width: 100%;
  height: 100%;
  /*margin-left: 20px;*/
}

.marquee-box {
  position: absolute;
  top: 50%;
  display: flex;
  white-space: nowrap;
  transform: translateY(-50%);
}

.marquee-list {
  margin-right: 10px;
}

.marquee-list span {
  padding: 0 0.04rem;
  color: #ffe17b;
  font-weight: 700;
}


.operatingList {
  padding: 5px 10px;
  display: flex;
  border-radius: 15px;
  /*background: #e8f2ff;*/
  float: left;
  /*color: #3788f6;*/
  /*margin-right: 24px;*/
  /*min-width: 170px;*/
  font-size: 14px;
  /*margin-bottom: 16px;*/
  margin: 0 24px 16px 0;
}

.operatingList {
  margin-left: 15px;
}

.operatingList > p {
  white-space: nowrap;
}

.operatingList > img {
  width: 16px;
  height: 16px;
  margin-right: 4px;
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/component/notice/index.vue